import { render, staticRenderFns } from "./creaPortafoglioModal.vue?vue&type=template&id=ef1e8f38&"
import script from "./creaPortafoglioModal.vue?vue&type=script&lang=ts&"
export * from "./creaPortafoglioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports